import { useMutation } from "react-query";

import { loadUnitInventory } from "@/api/Implementation/unitInventoryLoad";

export function useLoadUnitInventory() {
	return useMutation({
		mutationFn: (params) => loadUnitInventory(params),
		onSuccess: (response) => {
			if (response) {
				localStorage.setItem(
					"imp_state",
					JSON.stringify({
						implementation_state_id: response.implementation_state_id,
						is_implementation_completed: response.is_implementation_completed,
					}),
				);
			}
		},
	});
}
